import React from 'react';
import { Link } from 'react-router-dom';
import { FeatureCard, TIconName } from '@unmind/design-system';
import RoutePath from '../../App/RoutePath';
import { tracking } from '../../App/Tracking';
import { ContentType, ExploreCategory } from '../types';
interface CategoryButtonProps {
  category: ExploreCategory;
  iconName?: TIconName;
}

const CategoryButton = ({ category, iconName }: CategoryButtonProps) => {
  const { id, title, slug, internalName } = category;
  const path = `${RoutePath.Explore}/${slug}`;

  const trackCategoryClicked = () => {
    tracking.track('content-selected', {
      contentId: id,
      contentSlug: slug,
      contentDuration: null,
      contentType: ContentType.category,
      source: 'explore-category-button',
      contentCategoryPath: internalName,
      isFavourite: null,
    });
  };

  return (
    <FeatureCard
      titleAsChild
      size="small"
      icon={{
        name: iconName,
      }}
      data-testid="top-level-category-button"
    >
      <Link
        to={{
          pathname: path,
          state: {
            breadcrumbHistory: [
              {
                from: RoutePath.Explore,
              },
            ],
          },
        }}
        onClick={trackCategoryClicked}
      >
        {title}
      </Link>
    </FeatureCard>
  );
};

export default CategoryButton;
